import React from 'react';
import moment from 'moment';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import { env } from '~/commons/config';

export const FieldErpStatus = () => (
  <>
    <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">ERP Status</h6>
    <div className="form-group">
      <label>Manual</label>
      <FormCheckGroup name="erpSync.manualSync" type="checkbox" label="" asSwitch />
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="erpSync.lastSuccess" disabled label="Last Success" />
      </div>
      <div className="col">
        <FormGroup name="erpSync.lastSync" disabled label="Last Attempt" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="erpSync.errType" disabled label="Error Type" />
      </div>
      <div className="col">
        <FormGroup name="erpSync.message" disabled label="Message" />
      </div>
    </div>
  </>
);

export const erpStatusHelper = (data) => {
  if (!data) return {};
  const {
    lastSuccess, lastSync, errType = '', message = '',
  } = data;

  return {
    lastSuccess: lastSuccess
      ? moment(lastSuccess).format(env.f.dt)
      : '',
    lastSync: lastSync ? moment(lastSync).format(env.f.dt) : '',
    errType: message === 'Success sync' ? '' : errType,
    message,
  };
};
